import {
  Button,
  Checkbox,
  ConfigProvider,
  Form,
  Input,
  Select,
  Typography,
} from "antd";
import { getQueryParams } from "../../../../utilities/getQueryParams";
import CommonAdminTable from "../../../components/commonTable";
import { useEffect, useState, useRef } from "react";
import { useDispatch } from "react-redux";
import Alertify from "../../../../services/alertify";
import {
  CreateSubOrderAPI,
  FetchSubOrderItemsAPI,
} from "../../../../redux/actions/adminActions/subOrdersAction";
import { useLoader } from "../../../../utilities/useLoader";
import FullLoader from "../../../../utilities/fullLoader";
import { LoaderIcon } from "react-hot-toast";
import { DealerSubOrdersDetailsAPI } from "../../../../redux/actions/adminActions/orderDetailsAction";

const { Title } = Typography;

const CreateSubOrder = () => {
  const params = getQueryParams();
  const orderId = params.orderId;
  const ifDealer = params?.by_dealer;
  const dealerSubOrderId = params?.dealer_sub_order_id;
  console.log("The ids are:", ifDealer, "&", dealerSubOrderId);
  const [tableData, setTableData] = useState([]);
  const [formData, setFormData] = useState([]);
  const [errorMessages, setErrorMessages] = useState({});
  const [fullLoader, startFullLoader, endFullLoader] = useLoader();
  const [balanceLimit, setBalanceLimit] = useState(0);
  const [grandTotal, setGrandTotal] = useState(0);
  const [form] = Form.useForm();
  const columns = [
    {
      title: "Index",
      dataIndex: "index",
      key: "index",
    },
    {
      title: "Line Number",
      dataIndex: "line_number",
      key: "line_number",
    },
    {
      title: "Title",
      dataIndex: "product_title",
      key: "product_title",
    },
    {
      title: "Item Code",
      dataIndex: "erp_item_code",
      key: "erp_item_code",
      align: "center",
    },
    {
      title: "Remaining Quantity",
      dataIndex: "remaining_quantity",
      key: "remaining_quantity",
      align: "center",
    },
    {
      title: "Total Quantity",
      dataIndex: "total_quantity",
      key: "total_quantity",
      align: "center",
      hidden: true,
    },
    {
      title: "Per Unit Price",
      dataIndex: "per_unit_price",
      key: "per_unit_price",
      align: "center",
      hidden: true,
    },
    {
      title: "Total Price",
      dataIndex: "total_price",
      key: "total_price",
      align: "center",
      hidden: true,
    },
    {
      title: "Quantity to Ship",
      dataIndex: "qtyToShip",
      key: "qtyToShip",
      align: "center",
      render: (_, record) => (
        <div>
          <Input
            type="number"
            style={{ width: "100px" }}
            value={record.quantity_to_ship}
            onChange={(e) =>
              handleInputChange(e, record.key, "quantity_to_ship")
            }
            disabled={record.remaining_quantity === 0}
          />
          {errorMessages[record.key]?.quantity && (
            <div style={{ color: "red" }}>
              {errorMessages[record.key].quantity}
            </div>
          )}
        </div>
      ),
    },
    {
      title: "Branch Code",
      dataIndex: "branchCode",
      key: "branchCode",
      align: "center",
      render: (_, record) => (
        <div>
          <Select
            style={{ width: "150px" }}
            value={record.branch_code}
            onChange={(value) =>
              handleSelectChange(value, record.key, "branch_code")
            }
            options={[
              {
                label: "AAIPL Rudrapur",
                value: "RDP",
              },
            ]}
            disabled={record.remaining_quantity === 0}
          />
          {errorMessages[record.key]?.branch_code && (
            <div style={{ color: "red" }}>
              {errorMessages[record.key].branch_code}
            </div>
          )}
        </div>
      ),
    },
    {
      title: "Requested Delivery Date",
      dataIndex: "requestedDate",
      key: "requestedDate",
      align: "center",
      render: (_, record) => (
        <div>
          <Input
            type="date"
            id={`date-${record.key}`}
            style={{ width: "150px" }}
            min={today}
            value={record.requested_delivery_date || ""}
            onChange={(e) =>
              handleInputChange(e, record.key, "requested_delivery_date")
            }
            onBlur={(e) =>
              handleInputChange(e, record.key, "requested_delivery_date")
            }
            disabled={record.remaining_quantity === 0}
          />
          {errorMessages[record.key]?.date && (
            <div style={{ color: "red" }}>{errorMessages[record.key].date}</div>
          )}
        </div>
      ),
    },
    {
      title: "Make Order",
      dataIndex: "makeOrder",
      key: "makeOrder",
      align: "center",
      render: (_, record) => (
        <ConfigProvider
          theme={{
            token: {
              colorBorder: "#000",
            },
          }}
        >
          <Checkbox
            checked={record.make_order}
            onChange={(e) => handleCheckboxChange(e, record.key)}
            disabled={record.remaining_quantity === 0}
          />
        </ConfigProvider>
      ),
    },
  ];

  const updateGrandTotal = (updatedData) => {
    const total = updatedData
      .filter((item) => item.make_order) // Only consider checked rows
      .reduce((sum, item) => sum + (parseFloat(item.total_price) || 0), 0);
    setGrandTotal(total.toFixed(2));
  };

  const dispatch = useDispatch();
  const navigatedRef = useRef(false);
  const fetchedRef = useRef(false);
  // const dispatch = useDispatch();
  const today = new Date().toISOString().split("T")[0];

  // helper: convert various date strings to yyyy-mm-dd for <input type="date" />
  const formatDateForInput = (dateStr) => {
    // if already in YYYY-MM-DD format, return as-is
    if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) return dateStr;
    const d = new Date(dateStr);
    if (isNaN(d)) return "";
    return d.toISOString().split("T")[0];
  };

  useEffect(() => {
    const fetch = async () => {
      if (fetchedRef.current) return; // guard: run fetch only once per mount
      fetchedRef.current = true;
      try {
        startFullLoader();
        const fetchedData = await dispatch(
          FetchSubOrderItemsAPI({ order_id: orderId })
        ).unwrap();
        setBalanceLimit(fetchedData.data.balance_credit_limit);
        form.setFieldsValue({
          creditLimit: fetchedData.data.balance_credit_limit,
        });
        const getSubOrderDetails = async () => {
          if (!dealerSubOrderId) return null;

          try {
            const res = await dispatch(
              DealerSubOrdersDetailsAPI({
                sub_order_id: dealerSubOrderId,
                page: 1,
              })
            );

            const data = res?.payload?.data?.data;
            return data;
          } catch (err) {
            console.error(err);
            return null;
          }
        };
        let DealerSubOrderDetails = await getSubOrderDetails();
        console.log("extracted data:", DealerSubOrderDetails);

        const indexedData = fetchedData.data.data.map((item, index) => ({
          ...item,
          key: item.id || index,
          index: index + 1,
          per_unit_price: item.total_quantity
            ? (item.final_price / item.total_quantity).toFixed(2)
            : 0,
          quantity_to_ship: 0,
          branch_code: "",
          requested_delivery_date: "",
          make_order: false,
          total_price: item.total_quantity
            ? (item.final_price / item.total_quantity).toFixed(2)
            : 0,
        }));
        if (dealerSubOrderId) {
          const merged = indexedData.map((item) => {
            const match = DealerSubOrderDetails?.find(
              (d) =>
                String(d.erp_item_code).trim() ===
                String(item.erp_item_code).trim()
            );

            if (match) {
              // accept multiple possible date fields and normalize
              const rawDate =
                match.requested_delivery_date ??
                match.requestedDate ??
                match.requested_date ??
                null;
              const formatted = formatDateForInput(rawDate);
              // if formatted date is before today, use today
              const finalDate =
                formatted && formatted < today ? today : formatted || "";

              return {
                ...item,
                quantity_to_ship:
                  match.quantity_to_ship != null
                    ? Number(match.quantity_to_ship)
                    : item.quantity_to_ship,
                requested_delivery_date: finalDate,
                make_order: Boolean(match.quantity_to_ship) || item.make_order,
              };
            }

            return item;
          });
          console.log("The indexed data is:", indexedData);
          console.log("Merged Data:", merged);

          setTableData(merged);
          setFormData(merged);
          updateGrandTotal(merged); // Update Grand Total after setting data
          endFullLoader();
        } else {
          setTableData(indexedData);
          setFormData(indexedData);
          updateGrandTotal(indexedData); // Update Grand Total after setting data
          endFullLoader();
        }
        // dealerSubOrderId;
      } catch (err) {
        endFullLoader();
        // Alertify.error(err);
        Alertify.error(`${err.message}`);
        if (!navigatedRef.current) {
          navigatedRef.current = true;
          window.history.back();
        }
      }
    };

    fetch();
  }, [
    dispatch,
    orderId,
    form,
    dealerSubOrderId,
    startFullLoader,
    endFullLoader,
  ]);

  const handleInputChange = (e, key, field) => {
    const value =
      field === "quantity_to_ship"
        ? parseInt(e.target.value, 10)
        : e.target.value;

    const updatedData = formData.map((item) => {
      if (item.key === key) {
        const updatedItem = { ...item, [field]: value };

        if (field === "quantity_to_ship") {
          if (value < 1) {
            Alertify.error("Quantity to Ship must be at least 1.");
          } else if (value > item.remaining_quantity) {
            Alertify.error("Quantity to Ship must be ≤ Remaining Quantity.");
          } else {
            updatedItem.total_price = (
              parseFloat(updatedItem.per_unit_price) * value
            ).toFixed(2);
          }
        }
        return updatedItem;
      }
      return item;
    });

    setFormData(updatedData);
    updateGrandTotal(updatedData); // Update Grand Total dynamically
  };

  const handleCheckboxChange = (e, key) => {
    const updatedData = formData.map((item) =>
      item.key === key ? { ...item, make_order: e.target.checked } : item
    );
    setFormData(updatedData);
  };

  const handleSelectChange = (value, key, field) => {
    const updatedData = formData.map((item) =>
      item.key === key ? { ...item, [field]: value } : item
    );
    setFormData(updatedData);
  };
  const [loading, setLoading] = useState(false);
  const handleSubmit = () => {
    setLoading(true);
    // Check for any error messages
    const hasErrors = Object.values(errorMessages).some(
      (msg) => msg && (msg.quantity || msg.date)
    );

    // Check if at least one item has "Make Order" checked
    const subOrders = formData.filter((item) => item.make_order);
    if (subOrders.length === 0) {
      Alertify.error("Please select at least one item to make an order.");
      setLoading(false);
      return;
    }

    // Check for missing required fields in selected items
    const updatedErrorMessages = {};
    const missingFields = subOrders.some((item) => {
      if (
        !item.quantity_to_ship ||
        !item.branch_code ||
        !item.requested_delivery_date
      ) {
        if (!item.branch_code) {
          updatedErrorMessages[item.key] = {
            ...updatedErrorMessages[item.key],
            branch_code: "Branch Code is required.",
          };
        }
        if (!item.requested_delivery_date) {
          updatedErrorMessages[item.key] = {
            ...updatedErrorMessages[item.key],
            date: "Requested Delivery Date is required.",
          };
        }
        return true;
      }
      return false;
    });

    setErrorMessages(updatedErrorMessages);

    if (missingFields) {
      Alertify.error("Please fill in all required fields for selected items.");
      setLoading(false);

      return;
    }
    const grandTotalCalculated = formData
      .filter((item) => item.make_order) // Only consider checked rows
      .reduce((sum, item) => sum + (parseFloat(item.total_price) || 0), 0)
      .toFixed(2);
    setGrandTotal(grandTotalCalculated);
    // console.log("Grand Total", grandTotal);
    // console.log("Balance Limit", balanceLimit);
    //  **Check if Grand Total exceeds Credit Limit**
    if (parseFloat(grandTotalCalculated) > parseFloat(balanceLimit)) {
      Alertify.error(
        `Grand total (${parseFloat(grandTotalCalculated).toFixed(
          2
        )}) should be less than or equal to the Balanced credit limit (${parseFloat(
          balanceLimit
        ).toFixed(2)}).`
      );
      setLoading(false);

      return;
    }

    // Calculate the order value
    const orderValue = subOrders
      .reduce((total, item) => total + parseFloat(item.total_price || 0), 0)
      .toFixed(2);

    // Prepare the order data with updated remaining_quantity
    const orderData = {
      order_value: orderValue,
      order_id: orderId,
      ...(dealerSubOrderId ? { dealer_sub_order_id: dealerSubOrderId } : {}),
      sub_orders: subOrders.map((item) => ({
        ...item,
        remaining_quantity: item.remaining_quantity - item.quantity_to_ship,
      })),
    };

    // console.log("Order Data to Submit:", orderData);
    if (hasErrors) {
      Alertify.error("Please resolve all errors before submitting.");
      setLoading(false);
      return;
    }
    // Dispatch the API call
    console.log("Order data is:", orderData);
    dispatch(CreateSubOrderAPI(orderData))
      .then((response) => {
        // console.log("Response is:", response);
        Alertify.success("Sub Order created successfully!");
        window.history.back();
      })
      .catch((error) => {
        Alertify.error("Error in Creating Sub Order:", error);
        setLoading(false);
      });
  };

  return (
    <>
      {fullLoader ? (
        <FullLoader isLoading={true} />
      ) : (
        <>
          {loading ? (
            <div className="flex items-center justify-center pt-60">
              <LoaderIcon className="w-[3vw] h-[3vw] " />
            </div>
          ) : (
            <>
              <Title level={2} className="text-left">
                Create Sub Order for: {orderId}
              </Title>
              <CommonAdminTable columns={columns} data={formData} />
              <Form form={form} layout="vertical" hidden>
                <Form.Item label="Order Value" name="creditLimit">
                  <Input disabled />
                </Form.Item>
                <Form.Item label="Grand Total">
                  <Input
                    value={grandTotal}
                    disabled
                    style={{ fontWeight: "bold", color: "#1890ff" }}
                  />
                </Form.Item>
              </Form>
              <Button
                type="primary"
                className="rounded-md mt-4"
                onClick={handleSubmit}
              >
                Submit
              </Button>
            </>
          )}
        </>
      )}
    </>
  );
};

export default CreateSubOrder;
